module.exports = __webpack_public_path__ + "static/img/4bg_14.84631ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_14.png
// module id = 708
// module chunks = 1